function since(iso, now) {
    if (!iso)
        return 0;
    const at = Date.parse(iso);
    return Number.isFinite(at) ? Math.max(0, now - at) : 0;
}
/** The two totals as of `now`, the open span (if any) counted to `now`. */
export function clockTotalsOf(clock, now) {
    return {
        workedMs: clock.workedMs + since(clock.workingSince, now),
        waitingOnPersonMs: clock.waitingOnPersonMs + since(clock.waitingSince, now),
    };
}
//# sourceMappingURL=workItemClock.js.map